import React from "react";
import { Grid, Typography } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { TextInput } from "react-admin";
import { getMinDate, validateAttestationDate } from "./utils";

const CreateForm = ({ lastAttestationDate, startDate }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          source="attestationDate"
          label="Дата на заверка"
          noTime
          required={true}
          validate={validateAttestationDate(lastAttestationDate, startDate)}
        />
        {getMinDate(lastAttestationDate, startDate) && (
          <Typography color="primary">
            Датата трябва да е минимум 30 дни след последната заверка. Първа възможна дата:{" "}
            {getMinDate(lastAttestationDate, startDate)}
          </Typography>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
      >
        <TextInput
          source="note"
          label="Бележка"
        />
      </Grid>
    </Grid>
  );
};

export default CreateForm;
